import { EnvironmentProviders, importProvidersFrom, inject, LOCALE_ID, provideAppInitializer, Provider, } from '@angular/core';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { BrowserModule, Title } from '@angular/platform-browser';
import { ServiceWorkerModule } from '@angular/service-worker';
import { provideMomentDateAdapter } from '@angular/material-moment-adapter';
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
import { LoggerModule, TOKEN_LOGGER_SERVER_SERVICE } from 'ngx-logger';
import { localeIdFactory } from './app.module';
import { environment } from '../environments/environment';
import { HTTP_INTERCEPTOR_PROVIDERS } from './core/interceptors/interceptors';
import { ConfigurationService } from './core/configuration/configuration.service';
import { AppInMemoryDataService } from './app-in-memory-data.service';
import { CustomLoggerServerService } from './core/monitor/custom-logger-server-service';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { UpdateService } from './core/update/update.service';

export const UPDATE_INIT_PROVIDER = provideAppInitializer(() => {
  inject(UpdateService);
});

export const APP_BOOTSTRAP_PROVIDERS: (Provider | EnvironmentProviders)[] = [
  UPDATE_INIT_PROVIDER,
  importProvidersFrom(
    BrowserModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.serviceWorkerEnabled,
    }),
    LoggerModule.forRoot({ level: environment.logLevel }, {
      serverProvider: {
        provide: TOKEN_LOGGER_SERVER_SERVICE,
        useClass: CustomLoggerServerService,
      },
    }),
    AppRoutingModule,
    CoreModule,
  ),
  Title,
  HTTP_INTERCEPTOR_PROVIDERS,
  {
    provide: LOCALE_ID,
    useFactory: localeIdFactory(),
    deps: [ConfigurationService],
  },
  provideHttpClient(withXhr(), withInterceptorsFromDi()),
  importProvidersFrom(
    environment.production
      ? []
      : HttpClientInMemoryWebApiModule.forRoot(AppInMemoryDataService, {
        passThruUnknownUrl: true,
        apiBase: environment.apiUrl,
      }),
  ),
  provideMomentDateAdapter(),
];

